<template>
    <base-modal
        modal-id="loginModal"
        modal-dialog="centered,login"
    >
        <template #title>
            <h5 class="modal-title glitch-text glitch-text--login">Вход</h5>
        </template>
        <template>
            <login-form />
        </template>
    </base-modal>
</template>

<script>
import BaseModal from './base-modal';
import LoginForm from '../login-form';

export default {
    name: 'login-modal',

    components: { BaseModal, LoginForm },

    data() {
        return {
            count: 1,
        };
    },
};
</script>
